module.exports = __webpack_public_path__ + "img/token.8e450b82.svg";